<template>
  <side-panel-inner on-close="EventsIndexPage">
    <div slot="header" v-if="nextEvent" class="c-panel__header-title">
      <p>
        <a href="#" @click.prevent="goToNextEvent" class="next-article">
          <span>Next event:</span>
          <br />
          {{ nextEvent.title }}
        </a>
      </p>
      <div class="sticky-cover"></div>
      <div class="sticky-title" :class="{ show: showSticky }">
        {{ event.title }}
      </div>
    </div>

    <div slot="header" class="c-panel__header-title" v-else>
      <div class="sticky-cover"></div>
      <div class="sticky-title" v-if="showSticky">{{ event.title }}</div>
    </div>

    <loading v-if="!event_loaded" />
    <article v-else role="article">
      <header class="full-width">
        <section class="meta">
          <inline-list :withLead="true" :ordered="false" withInnerPadding>
            <li class="p-right-20">Event</li>
            <li>
              <date showIcon title="Posted" :date="event.created_time" />
            </li>
            <li>
              <meta-field show-icon icon="share">
                <base-button as-link @click="addQrCode = true"
                  >Share Event</base-button
                >
              </meta-field>
            </li>
          </inline-list>
        </section>
        <h1 class="p-bottom-0">{{ event.title }}</h1>
        <p>
          <strong class="blue">Location:</strong>
          {{ event.location.name }}
          <br />
          <strong class="blue">Date &amp; Time:</strong>
          &nbsp;{{ dateString }}
        </p>
        <p>
          <base-button icon-before="calendar" inline @click="addToCalendar"
            >Add to calendar</base-button
          >&nbsp;
          <base-button icon-before="star" inline @click="toggleInterested" :primary="event.user_favourite"
            >Interested</base-button
          >
        </p>
        <div class="c-interested">
          <p class="m-bottom-0">
            <em>{{ event.favourite_count }}</em>
            {{ event.favourite_count == 1 ? "person is" : "people are" }}
            interested in this event
          </p>
        </div>
      </header>

      <section class="content">
        <section
          class="header-image full-width"
          slot="header-image"
          v-if="event.default_image && image_loaded"
        >
          <image-loader :image="event.default_image" />
        </section>

        <main class="article-content">
          <div
            class="c-element-container"
            :class="{ [`c-element-container--${element.type}`]: true }"
            v-for="(element, index) in event.elements"
            :key="index"
          >
            <pb-element :element="forRender[index]"></pb-element>
          </div>
        </main>
      </section>
    </article>
    <modal
      v-if="addQrCode"
      show-close-button
      @close="addQrCode = false"
      class="ta-left"
    >
      <h1 slot="header">Create QR Code</h1>
      <qr-generator />
    </modal>
  </side-panel-inner>
</template>

<script>
import Date from "@/components/elements/Date";
import PbElement from "@/components/PbElement";
import InlineList from "@/components/Lists/InlineList";
import ImageLoader from "@/components/elements/ImageLoader";
import AvatarList from "@/components/AvatarList";
import MetaField from "@/components/MetaField";
import QrGenerator from "@/components/contentElements/modals/TheQrGenerator";
import { mapState } from "vuex";

export default {
  name: "SingleEvent",

  data() {
    return {
      image_loaded: false,
      event_loaded: false,
      showSticky: false,
      addQrCode: false,
    };
  },

  beforeMount() {
    const vm = this;
    const { id } = this.$route.params;

    this.$store.dispatch("Events/read", id).then(() => {
      this.$store.commit(
        "pageElements/setPageElements",
        this.$store.state.Events.event.elements
      );
      vm.image_loaded = true;
      vm.event_loaded = true;
    });
  },

  computed: {
    ...mapState("Events", ["event", "events"]),

    dateString() {
      let string = this.$dayjs(this.event.start_date).format(
        "DD / MM / YYYY HH:mm"
      );
      const endtime = this.$dayjs(this.event.start_date)
        .add(this.event.duration, "minute")
        .format("HH:mm");
      return `${string} - ${endtime}`;
    },

    nextEvent() {
      if (this.events.length > 0) {
        const currentIndex = this.events.findIndex(
          (item) => item.id === this.event.id
        );
        if (currentIndex >= 0) {
          return this.events[currentIndex + 1];
        }
      } else {
        return {};
      }
    },
    prevLink() {
      if (this.events.length > 0) {
        const currentIndex = this.events.findIndex(
          (item) => item.id === this.event.id
        );
        if (currentIndex >= 0) {
          return this.events[currentIndex - 1];
        }
      } else {
        return {};
      }
    },
    forRender() {
      {
        return this.$store.getters["pageElements/forRender"];
      }
    },
  },

  updated() {
    /**
     * Intersection observer for showing sticky menu
     */
    var observer;

    var options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    observer = new IntersectionObserver(this.ioCallback, options);
    observer.observe(document.querySelector("header.full-width"));
  },

  methods: {
    async toggleInterested() {
      const endpoint = this.event.user_favourite
        ? "Events/unfavourite"
        : "Events/favourite";
      try {
        await this.$store.dispatch(endpoint, this.event.id);
        this.$store.dispatch(
          "notifications/create",
          {
            body: `Your preference has been updated`,
            type: "success",
          },
          { root: true }
        );
      } catch (err) {
        console.log(
          "🚀 ~ file: Event.vue ~ line 251 ~ toggleInterested ~ err",
          err
        );
        this.$store.dispatch(
          "notifications/create",
          {
            body: `There was a problem, please try again`,
            type: "danger",
          },
          { root: true }
        );
      }
    },
    addToCalendar() {
      this.$ics.removeAllEvents();
      this.$ics.addEvent(
        "en-us",
        this.event.title,
        "",
        this.event.location.name.replace(/,/g, "\\,"),
        this.$dayjs(this.event.start_date).format("YYYY-MM-DDTHH:mm"),
        this.$dayjs(this.event.start_date)
          .add(this.event.duration, "minute")
          .format("YYYY-MM-DDTHH:mm"),
        document.location.href,
        null
      );

      this.$ics.download(this.event.title);
    },
    ioCallback(entries, observer) {
      const entryToCheck = entries[0];
      if (!entryToCheck.isIntersecting) {
        this.showSticky = true;
      } else {
        this.showSticky = false;
      }
    },
    goToNextEvent() {
      const vm = this;
      const { nextEvent } = this;
      this.$store.commit("Event/GET_EVENT", []);
      this.image_loaded = false;

      this.$store.dispatch("Events/read", nextEvent.id).then((resp) => {
        this.$store.commit(
          "pageElements/setPageElements",
          this.$store.state.Events.event.elements
        );
        this.image_loaded = true;
        vm.$router.push({
          name: "EventsSinglePage",
          params: { id: nextEvent.id },
        });
      });
    },
  },

  components: {
    Date,
    PbElement,
    InlineList,
    ImageLoader,
    AvatarList,
    MetaField,
    QrGenerator,
  },
};
</script>

<style scoped lang="scss">
.sticky-cover {
  width: 100%;
  top: 0;
  right: 0;
  height: 90px;
  position: absolute;
  background: white;
  z-index: -1;
}
.sticky-title {
  position: absolute;
  left: 0;
  width: 100%;
  background: #f3f6f6;
  padding: 20px;
  top: 30px;
  z-index: -2;
  transition: all ease-in-out 0.2s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.11);
  font-size: 16px;
  &.show {
    top: 90px;
  }
}
.full-width {
  margin-left: -10px;
  min-width: calc(100% + 20px);
  box-sizing: border-box;

  @media screen and (min-width: 1024px) {
    margin-left: -3em;
    min-width: calc(100% + 6em);
  }

  @media screen and (min-width: 1170px) {
    margin-left: -6em;
    min-width: calc(100% + 12em);
  }
}

.header-image {
  max-height: 300px;
  overflow: hidden;

  position: relative;

  margin-bottom: 20px;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    content: "";
    box-shadow: 0 0 10px 6px rgba(0, 0, 0, 0.11);
    z-index: 2;
    height: 1px;
  }
}

.next-article {
  color: #697884;
  font-weight: lighter;
  text-decoration: none;
  position: relative;
  display: block;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.2;
  font-family: $font-frutiger-light;
  padding-right: 20px;

  span {
    color: $colour-cactus-core-green;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.1;
    font-family: $font-frutiger-bold;
  }

  &:after {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -14px;
    display: block;
    content: " ";
    background-image: url("/assets/arrow.svg");
    background-size: 28px 28px;
    height: 28px;
    width: 28px;
    transition: all ease-in-out 0.2s;
  }

  &:hover {
    &:after {
      right: -5px;
    }
  }
}

article {
  img {
    min-height: 200px;
    width: 100%;
  }
}

header {
  background: #f0f5fb;
  margin-top: -110px;
  padding-top: 110px;

  padding-left: 2em;
  padding-right: 2em;
  min-width: calc(100% + 4em);
  box-sizing: border-box;

  h1 {
    padding-bottom: 0.67em;
    margin-bottom: 0;
  }

  @media screen and (min-width: 1024px) {
    padding-left: 3em;
    padding-right: 3em;
    min-width: calc(100% + 6em);
  }

  @media screen and (min-width: 1170px) {
    padding-left: 6em;
    padding-right: 6em;
    min-width: calc(100% + 12em);
  }
}

header {
  padding-bottom: 20px;

  @media screen and (min-width: 1024px) {
    background-image: url(/assets/IconEvent.png);
    background-position: bottom left;
    background-repeat: no-repeat;
    background-size: 15%;
    padding-left: 180px;
  }
  strong {
    color: $colour-cactus-core-green;
  }

  p {
    line-height: 1.2;
  }
}

.c-interested {
  em {
    color: $colour-cactus-core-green;
    font-style: normal;
    font-weight: bold;
  }
}
</style>
